import { createDiv, createDropdown, createPara, createSVG, createTextArea, createTextField } from "../utils/utils";
import { db } from "../firebase.js";
import { doc, deleteDoc, setDoc } from "firebase/firestore";
import { fetchUserTasks, countingUserTasks } from "./mainContent";

export default function clickedTask() {
    const root = document.querySelector(".container");
    const getMyTaskMain = createDiv(root, "clicked-task-main");
    const getMain = document.querySelector(".main");
  
    // Header
    const getMyTaskHeader = createDiv(getMyTaskMain, "my-task-header");
    createPara(getMyTaskHeader, "my-task-header-title", "Task:");
    const getCloseMyTask = createSVG(getMyTaskHeader, "my-task-close-svg","M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z");
    getCloseMyTask.addEventListener("click", () => {
      getMyTaskMain.classList.remove("quick-show");
      getMain.classList.remove("adjust-main-right");
    });
  
    // Inputs (created ONCE)
    createTextField(getMyTaskMain, "my-task-title", "Task Title");
    createTextArea(getMyTaskMain, "my-task-descirption", "Description");
  
    const getMyTaskPriority = createDiv(getMyTaskMain, "my-task-priority");
    createDropdown(getMyTaskPriority, "priority", "Choose Priority", "priority", [
      { value: "high", label: "High" },
      { value: "medium", label: "Medium" },
      { value: "low", label: "Low" },
    ]);
  
    const getMyTaskDueDate = createDiv(getMyTaskMain, "my-task-due-date");
    createPara(getMyTaskDueDate, "due-date-title", "Due date");
    const getClickedTaskDueDate = createTextField(getMyTaskDueDate, "date-time-input", "Date & Time", "date");
    getClickedTaskDueDate.min = new Date().toISOString().split("T")[0];

    const getChangeAndDeleteTask = createDiv(getMyTaskMain, "change-delete-task-main");
    const getDeleteTaskMain = createDiv(getChangeAndDeleteTask,"delete-task-div");
    createPara(getDeleteTaskMain,"delete-task-text","Delete Task");
    const getChangeTaskMain = createDiv(getChangeAndDeleteTask,"change-task-div");
    createPara(getChangeTaskMain,"save-task-text","Save Changes");  
}

export function clickedTaskDetails(taskTitle, taskDescription, taskPriority, taskDueDate, getMyTaskId) {
    const getMyTaskTitle = document.getElementById("my-task-title");
    const getMyTaskDetail = document.getElementById("my-task-descirption");
    const getTaskPriority = document.getElementById("priority");
    const getTaskDueDate = document.getElementById("date-time-input");
    const getDeleteTaskMain = document.querySelector(".delete-task-div");
    const getChangeTaskMain = document.querySelector(".change-task-div");
    const getClickedTaskMain = document.querySelector(".clicked-task-main");
  
    // Fill values (NO new UI created)
    getMyTaskTitle.value = taskTitle;
    getMyTaskDetail.value = taskDescription;
    getTaskPriority.value = taskPriority;
    getTaskDueDate.value = taskDueDate;
  
    // Clear old event listeners before adding new
    getDeleteTaskMain.replaceWith(getDeleteTaskMain.cloneNode(true));
    getChangeTaskMain.replaceWith(getChangeTaskMain.cloneNode(true));
  
    const newDeleteBtn = document.querySelector(".delete-task-div");
    const newSaveBtn = document.querySelector(".change-task-div");
  
    newDeleteBtn.addEventListener("click", () => {
      getClickedTaskMain.classList.remove("quick-show");
      deleteTaskById(getMyTaskId);
    });
  
    const taskRef = doc(db, "Tasks", getMyTaskId);
    newSaveBtn.addEventListener("click", async () => {
      await saveTaskChanges(
        taskRef,
        getMyTaskTitle.value,
        getMyTaskDetail.value,
        getTaskPriority.value,
        getTaskDueDate.value
      );
    });
}
  
  
async function deleteTaskById(id) {

    const getSidebarHighTaskList = document.querySelector(".sidebar-high-tasks");
    const getSidebarNormalTaskList = document.querySelector(".sidebar-normal-tasks");
    const getSidebarLowTaskList = document.querySelector(".sidebar-low-tasks");
    const getSidebarTodayTask = document.querySelector(".sidebar-today-tasks");
    const getSidebarPastTask = document.querySelector(".sidebar-past-tasks");
    const getSidebarUpcomingTask = document.querySelector(".sidebar-upcoming-tasks");
    let task;
    const root = document.querySelector(".main");

    // Findling out when user saved the task, he was on which category i.e. Today task, upcoming etc then passing that to fetchUserTask() function.
      if (getSidebarHighTaskList.classList.contains("selected-task") || getSidebarHighTaskList.classList.contains("selected-task2"))
       {
         task = "high";
       }
       else if (getSidebarNormalTaskList.classList.contains("selected-task") || getSidebarNormalTaskList.classList.contains("selected-task2")) {
         task = "medium";
       }
       else if  (getSidebarLowTaskList.classList.contains("selected-task") || getSidebarLowTaskList.classList.contains("selected-task2")) {
         task = "low";
       }
       else if (getSidebarTodayTask.classList.contains("selected-task") || getSidebarTodayTask.classList.contains("selected-task2")) {
         task = "today";
       }
       else if (getSidebarPastTask.classList.contains("selected-task") || getSidebarPastTask.classList.contains("selected-task2")) {
         task = "past";
       }
       else if (getSidebarUpcomingTask.classList.contains("selected-task") || getSidebarUpcomingTask.classList.contains("selected-task2")) {
         task = "upcoming";
       }  
        fetchUserTasks(task);
        countingUserTasks();
    // --------------------------------
    
    try {
      const taskRef = doc(db, "Tasks", id);
      root.classList.remove("adjust-main-right")
      await deleteDoc(taskRef);
      console.log(`Task with id ${id} deleted successfully ✅`);
    } catch (error) {
      console.error("Error deleting task:", error);
    }
}

async function saveTaskChanges(taskRef,title,desc,priority,dueDate){

    const getSidebarHighTaskList = document.querySelector(".sidebar-high-tasks");
    const getSidebarNormalTaskList = document.querySelector(".sidebar-normal-tasks");
    const getSidebarLowTaskList = document.querySelector(".sidebar-low-tasks");
    const getSidebarTodayTask = document.querySelector(".sidebar-today-tasks");
    const getSidebarPastTask = document.querySelector(".sidebar-past-tasks");
    const getSidebarUpcomingTask = document.querySelector(".sidebar-upcoming-tasks");
    const root = document.querySelector(".main");
    const getClickedTaskMain = document.querySelector(".clicked-task-main");
    let task;

    // Findling out when user saved the task, he was on which category i.e. Today task, upcoming etc then passing that to fetchUserTask() function.
        if (getSidebarHighTaskList.classList.contains("selected-task") || getSidebarHighTaskList.classList.contains("selected-task2")) {
            task = "high";
        }
        else if (getSidebarNormalTaskList.classList.contains("selected-task") || getSidebarNormalTaskList.classList.contains("selected-task2")) {
            task = "medium";
        }
        else if (getSidebarLowTaskList.classList.contains("selected-task") || getSidebarLowTaskList.classList.contains("selected-task2")) {
            task = "low";
        }
        else if (getSidebarTodayTask.classList.contains("selected-task") || getSidebarTodayTask.classList.contains("selected-task2")) {
            task = "today";
        }
        else if (getSidebarPastTask.classList.contains("selected-task") || getSidebarPastTask.classList.contains("selected-task2")) {
            task = "past";
        }
        else if (getSidebarUpcomingTask.classList.contains("selected-task") || getSidebarUpcomingTask.classList.contains("selected-task2")) {
            task = "upcoming";
        }  
    try {
        await setDoc(taskRef, {
          title: title,
          description: desc,
          priority: priority,
          dueDate: dueDate,
        }, { merge: true }); // merge ensures other fields stay untouched
        fetchUserTasks(task);
        countingUserTasks();
        getClickedTaskMain.classList.remove("quick-show");
        root.classList.remove("adjust-main-right");
      } 
      catch (error) {
        console.error("Error updating task: ", error);
      }
}